<template>
  <div id="app">
    <router-view/>
    <Modal/>
    <LoadingOverlay/>
  </div>
</template>

<script>
import Modal from "./components/Modal.vue";
import LoadingOverlay from "./components/LoadingOverlay.vue";

export default {
  components: {
    Modal,
    LoadingOverlay,
  }
}
</script>

<!-- Global CSS Settings -->
<style lang="scss">
@font-face {
  font-family: 'form-icons';
  src: url('./assets/form-icons.ttf');
  font-style: normal;
  font-weight: normal;
}

body {
  min-height: 100vh;
  background-color: rgb(240, 240, 240);
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding-bottom: 10rem;
  overflow-x: hidden;
}

.block {
  max-width: 800px;
  width: 100%;
  padding: 1.6rem 1.6rem;
  margin: 0 auto;

  &.is-flex {
    justify-content: center;
    align-items: center;
  }

  &.has-white-background {
    background-color: rgba(255, 255, 255, 1);
  }
}

.content-block {
  padding-top: 2.5rem;

  &.small-padding {
    padding-top: 1.5rem;
  }

  .block {
    border: 1px solid rgb(230, 230, 230);
    box-shadow: 0px 1px 3px rgba(200, 200, 200, 0.25);

    .inner-block {
      padding-bottom: 1.6rem;

      &.is-flex {
        flex-wrap: wrap;
      }

      &:last-of-type {
        padding-bottom: 0;
      }
    }

    .col-1 {
      width: 100%;
      padding-top: 2rem;
    }

    .col-2 {
      width: 50%;
      padding-top: 2rem;

      .button, .select, select {
        width: 100%;
      }

      &:nth-child(1), &:nth-child(2) {
        padding-top: 0rem;
      }

      &:nth-child(odd) {
        padding-right: .8rem;
      }

      &:nth-child(even) {
        padding-left: .8rem;
      }
    }

    .title {
      font-size: 0.9rem;
      text-transform: uppercase;
      margin-bottom: 0.3rem;
    }

    .title-container {
      display: flex;
      align-items: flex-start;
      gap: 5px;
      margin-bottom: 0.3rem;

      @media screen and (max-width: 680px) {
        justify-content: space-between;
      }

      .title {
        margin: 0;
        max-width: 500px;
      }
    }

    .subtitle {
      font-size: 0.82rem;
      margin-top: 0rem !important;
      margin-bottom: 1.4rem;
      width: 100%;
    }

    .button {
      width: 50%;
      font-size: 0.8rem;
      text-transform: uppercase;
      padding: 1.3rem 3rem;
      border-radius: 2px;
      transition: all 0.3s ease-in-out;
      font-weight: 500;

      &.is-primary {
        background-color: #004e9f;
        color: #fff;

        &:hover {
          background-color: #024286;
        }
      }

      &.is-primary.is-outlined {
        background-color: transparent;
        border-color: #004e9f;
        color: #004e9f;

        &:hover {
          background-color: #024286;
          color: #fff;
        }
      }
    }

    input.checkbox,
    .select select,
    input {
      height: 2.75em;
      font-size: 1rem;
      border: 1px solid rgba(200, 200, 200, 1);
      border-radius: 2px;
      padding-left: 0.8em;
      padding-bottom: 0.4em;
      transition: all 0.1s ease-in-out;

      &:hover {
        border: 1px solid rgba(150, 150, 150, 1);
      }
    }

    input.checkbox {
      -webkit-appearance: none;
      height: 1.75em;
      width: 1.75em;

      &:before, &:after {
        width: 3px;
        content: '';
        position: absolute;
        background: #004e9f;
      }

      &:before {
        height: 8px;
        position: absolute;
        bottom: 5px;
        left: 5px;
        transform-origin: center top;
        transform: rotate(-45deg) scaleY(0);
        transition: transform .05s ease-out .1s;
      }

      &:after {
        height: 11px;
        position: absolute;
        bottom: 9px;
        left: 10px;
        transform-origin: center bottom;
        transform: rotate(45deg) scaleY(0);
        transition: transform .05s ease-out;
      }

      &:checked {
        &:before {
          transform: rotate(-45deg) scaleY(1);
          transition: transform .05s ease-out;

        }

        &:after {
          transform: rotate(45deg) scaleY(1);
          transition: transform .05s ease-out .1s;

        }
      }
    }

    .select:not(.is-multiple):not(.is-loading)::after, .navbar-link:not(.is-arrowless)::after {
      margin-top: -0.25em;
      border-width: 2px;
      border-radius: 0px;
    }

    .select:not(.is-multiple):not(.is-loading)::after {
      right: 0.95em;
    }

    .select:not(.is-multiple):not(.is-loading)::after {
      border-color: rgba(75, 75, 75, 1);
    }

    .select select:focus, .select select.is-focused, .select select:active, .select select.is-active,
    input:focus {
      border-color: #004e9f;
      color: #024286;
      box-shadow: 0 0 0 0.125em rgba(7, 61, 150, 0.2);
    }

    input {
      -webkit-box-shadow: none;
      box-shadow: none;
    }

    .vdp-datepicker {
      input {
        width: 100%;
        height: 44px;
        font-size: 0.98rem;
        outline: none;
        position: relative;
        display: block;
        cursor: pointer;
      }

      .vdp-datepicker__calendar {
        background: rgb(252, 252, 252);
        padding: .9rem;
        border-radius: 3px;
        box-shadow: 0 6px 26px rgba(35, 35, 35, 0.25);
        z-index: 100 !important;
        display: block;

        header .prev,
        header .next {
          border-radius: 50%;
          transition: all 0.3s ease-in-out;
        }

        .cell {
          border-radius: 50%;
        }

        .cell.selected {
          background: #004e9f;
          color: #fff;
          transition: all 0.3s ease-in-out;
        }

        .cell.month {
          border-radius: 2px;

          .selected,
          &:hover,
          &:focus {
            border-radius: 2px;
          }
        }

        .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
          border: 1px solid #004e9f;
        }
      }
    }

    .control.has-icons-left .icon, .control.has-icons-right .icon {
      color: #dbdbdb;
      top: 0.22em;
    }
  }

  .input-note {
    font-size: 0.7rem;
    margin-top: 0.25rem;
    margin-left: 0.15rem;
  }

  ul.input-note {
    padding-left: 2em;
    list-style: initial;
  }

  .note-block {
    width: 100%;
    border-top: 1px solid rgb(200, 200, 200);
    padding-top: 0.4rem;

    .subtitle {
      margin-bottom: 0;
    }
  }

  // Blank Target Link
  a {
    color: #363636;

    svg {
      margin-left: 3px;
    }
  }

  .inct-info-element-tooltip, .content-block-inner {
    a {
      color: #3273dc;
    }
  }

  .inct-info-element-tooltip {
    p {
      margin: 0 !important;
    }
  }
}

// IE 11 Block Fix
.content-block.ie-fix {
  position: relative;
  z-index: 100;
}

i {
  border: solid;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 4px;
  position: absolute;
  top: 15px;
}

.left {
  transform: rotate(135deg);
  left: 2.3em;
}

.right {
  transform: rotate(-45deg);
  right: 2.25em;
}

.connection-note {
  font-size: 0.9em;
  margin-top: .9em;
  font-weight: 500;
  color: rgba(120, 120, 120, 1);
  display: block;
  pointer-events: none;

  svg {
    margin-right: .2em;
    margin-top: 1px;
  }

  &.loading {
    padding-left: 2em;
  }
}

.loading-block {
  pointer-events: none;

  .control.is-loading.is-small:after {
    font-size: 1.2rem;
  }

  .control.is-loading::after {
    right: initial;
    left: 0em;
    top: 0em;
  }

  .button.is-loading::after, .select.is-loading::after, .control.is-loading::after, .loader {
    border: 2px solid #383838;
    border-right-color: transparent;
    border-top-color: transparent;
  }
}

.adj-lineheight {
  line-height: 140%;
}

// Global Modal Styling
.darken-bg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(60, 60, 60, 0.8);
  z-index: 100;

  .block {
    width: 90%;
    max-width: 500px;
    position: absolute;
    top: calc(50% - 100px);
    left: 0;
    right: 0;
    display: block;
    box-shadow: 0px 2px 4px rgba(35, 35, 35, 0.25);
  }
}

// Global Transition Styling
.fade-enter-active {
  transition: all .3s ease-in-out;
}

.fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.fade-enter, .fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.slide-fade-alt-enter-active {
  transition: all .4s ease-in-out;
}

.slide-fade-alt-leave-active {
  transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-alt-enter, .slide-fade-alt-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateY(10px);
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all .4s ease-in-out;
}

.slide-fade-leave-active {
  transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateY(100px);
  opacity: 0;
}

.slide-fade-delay-enter-active {
  transition: all .4s ease-in-out;
  transition-delay: .2s;
}

.slide-fade-delay-leave-active {
  transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-delay-enter, .slide-fade-delay-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateY(100px);
  opacity: 0;
}

.slide-fade-delay-alt-enter-active {
  transition: all .4s ease-in-out;
  transition-delay: .4s;
}

.slide-fade-delay-alt-leave-active {
  transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-delay-alt-enter, .slide-fade-delay-alt-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateY(100px);
  opacity: 0;
}

@media all and (min-width: 680px) and (max-width: 800px) {
}

@media (max-width: 680px) {
  #app {
    padding-bottom: 8rem;
  }

  .content-block {
    padding-top: 1.5rem;

    &.small-padding {
      padding-top: 1rem;
    }

    .block {
      padding: 1.2rem 1.2rem;
      border-left: none;
      border-right: none;

      .inner-block {
        padding-bottom: 1.4rem;
      }

      .subtitle {
        font-size: 0.7rem;
        margin-bottom: 1.2rem;
      }

      .button {
        width: 100%;
        font-size: 0.7rem;
        padding: 1.3rem 2rem;
      }

      .col-2 {
        width: 100%;
        padding-top: 1rem !important;

        &.has-mobile-adj {
          padding-top: 1.4rem !important;
        }

        &:first-of-type {
          padding-top: 0rem !important;
        }

        &:nth-child(odd) {
          padding-right: 0rem;
        }

        &:nth-child(even) {
          padding-left: 0rem;
        }

      }

      .select select, input {
        padding-left: 0.6em;
      }

      .select {
        select:not([multiple]) {
          padding-right: 1.7em;
        }
      }

      .select:not(.is-multiple):not(.is-loading)::after {
        right: 0.75em;
      }

      .select-extended {
        margin-top: 0.6rem;
      }

      .select-extended-sum {
        padding-top: 1rem;
      }

    }
  }

  .left {
    left: 1.3em;
  }

  .right {
    right: 1.3em;
  }

}

</style>